import { render, staticRenderFns } from "./InvoiceSupplierFiche.vue?vue&type=template&id=0b2a92dd&"
import script from "./InvoiceSupplierFiche.vue?vue&type=script&lang=js&"
export * from "./InvoiceSupplierFiche.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports